'use strict';

angular.module('invitations')
    .component('invitationsTable', {
        templateUrl: 'js/modules/invitations/components/table/template.html',
        controller: 'InvitationsTableController',
    });
